import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/auth-store";
import { LoginModal } from "../components/UI/LoginModal";

interface CommonLayoutProps {
  children: React.ReactNode;
  showNavBar?: boolean;
  showAuth?: boolean;
}

export const ShopCommonLayout: React.FC<CommonLayoutProps> = ({
  children,
  showNavBar = true,
}) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  return (
    <div>
      {/* Header */}
      <header className="relative z-50 bg-white">
        <div
          className="py-[12px] flex justify-center items-center  /
      bg-[#F2F2F2] w-full"
        >
          <div className="max-w-[1200px] text-[14px] mx-[2rem] w-full flex flex-row justify-between">
            <div className="flex flex-row gap-[20px]">
              <div className="text-[#787A7D]">셀프 디자인</div>
              <div className="text-[#787A7D]">작업 가이드</div>
            </div>

            <div className="flex flex-row gap-[20px]">
              <div className="text-[#787A7D]">고객센터</div>
              <div
                role="button"
                onClick={() => {
                  setIsLoginModalOpen(true);
                }}
              >
                <div className="text-[#787A7D]">로그인</div>
              </div>
              <a href="/shop/signup">
                <div className="text-[#787A7D]">회원가입</div>
              </a>
            </div>
          </div>
        </div>
        {showNavBar ? (
          <div
            className="py-[12px] flex justify-center items-center  /
      bg-white w-full"
          >
            <div className="max-w-[75rem] text-[0.875rem] mx-[2rem] w-full flex flex-row justify-between">
              <div className=" py-[16px] w-full flex-col">
                <div className="w-full flex flex-row justify-between mb-4">
                  <h1 className="text-start text-[1.125rem]">
                    PrintShop
                  </h1>
                  <div className="flex flex-row gap-[1.5rem] items-center">
                    <div className="relative">
                      <img
                        className="w-[1.25rem]"
                        alt="유저 아이콘"
                        src="/assets/icons/Profile.svg"
                      />
                    </div>
                    <div className="relative">
                      <div className="absolute bottom-2 left-4 w-[1rem] h-[1rem] bg-[#FB2C36] rounded-full text-white text-[0.625rem]">
                        3
                      </div>
                      <img
                        className="w-[1.25rem]"
                        alt="쇼핑 카트 아이콘"
                        src="/assets/icons/Buy.svg"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-row gap-3">
                  <div>배너</div>
                  <div>포스터</div>
                  <div>명함</div>
                  <div>책자</div>
                </div>
              </div>

            </div>
          </div>
        ) : null}
      </header>

      {/* Main Content */}
      <main>{children}</main>

      {/* Footer */}
      <footer className="bg-gray-100 py-12 md:py-20">
        <div className="max-w-screen-xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-16">
            {/* 이용안내 */}
            <div className="text-left w-full md:w-auto">
              <h3 className="font-['Pretendard'] font-medium text-gray-900 text-left text-base md:text-lg mb-2 md:mb-[9px]">
                이용안내
              </h3>
              <div className="text-left">
                <p className="font-['Noto_Sans_CJK_KR'] font-bold text-gray-900 text-left text-xl md:text-2xl mb-6 md:mb-[30px]">
                  010-3324-0487
                </p>
                <p className="font-['Pretendard'] font-medium text-gray-700 text-left text-sm md:text-[14px] mb-2 md:mb-[9px]">
                  평일 09:00~18:00
                </p>
                <p className="font-['Pretendard'] font-medium text-gray-700 text-left text-sm md:text-[14px]">
                  점심 12:00~13:00 (주말, 공휴일은 제외)
                </p>
              </div>
            </div>

            {/* 회사 정보 */}
            <div className="text-left w-full md:w-auto">
              <div className="flex flex-wrap mb-4 md:mb-6 text-left gap-4 md:gap-[35px]">
                <a
                  href="/services"
                  className="font-['Pretendard'] font-medium text-gray-700 hover:text-gray-900 text-sm md:text-[15px]"
                >
                  서비스소개
                </a>
                <a
                  href="/terms"
                  className="font-['Pretendard'] font-medium text-gray-700 hover:text-gray-900 text-sm md:text-[15px]"
                >
                  이용약관
                </a>
                <a
                  href="/privacy"
                  className="font-['Pretendard'] font-medium text-gray-700 hover:text-gray-900 text-sm md:text-[15px]"
                >
                  개인정보보호정책
                </a>
              </div>
              <div className="text-gray-600 text-left mt-6 md:mt-[45px]">
                <p className="font-['Pretendard'] font-medium text-left text-xs md:text-[14px] mb-2 md:mb-2">
                  (주) 데이토즈 / 대표: 김은아 / 개인정보 관리 책임자: 김은아
                </p>
                <p className="font-['Pretendard'] font-medium text-left text-xs md:text-[14px] mb-2 md:mb-2">
                  주소: 서울 금천구 디지털로9길 99 스타밸리, 805호
                </p>
                <p className="font-['Pretendard'] font-medium text-left text-xs md:text-[14px]">
                  사업자등록번호: 637-81-01964 / 통신판매신고번호: 제
                  2024-서울금천-1792호
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Login Modal */}
      <LoginModal
        isOpen={isLoginModalOpen}
        companyId={null}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </div>
  );
};
